'use client';

import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { ReactNode } from 'react';

const stripePromise = loadStripe(process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_API_KEY!);

const StripeProvider = ({ children }: { children: ReactNode }) => {
   {
      return <Elements stripe={stripePromise}>{children}</Elements>;
   }
};

export default StripeProvider;
